/*
 * Descarga del Excel del tablero (GET /attendance/exportar/, etapa 5): nombre del archivo, guardado del
 * blob en el navegador y mensaje de error. Con responseType 'blob' axios entrega también los errores
 * como Blob, así que el `mensaje` del backend (401 sin permiso, 406 filtros o rango) hay que leerlo del blob.
 * El nombre lo arma el cliente solo con la sección y las fechas del rango (nunca con datos libres).
 */
import {errorMessage} from './errors';

/** 'Marcaciones_ingresos_2026-09-01_2026-09-30.xlsx' (igual que el Content-Disposition del backend). */
export function exportFileName(section, range) {
    return `Marcaciones_${section}_${range.desde}_${range.hasta}.xlsx`;
}

function readBlobText(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
    });
}

/** Mensaje en español de un error de descarga (lee el JSON del backend si vino dentro de un Blob). */
export async function downloadErrorMessage(error) {
    const response = error && error.response;
    if (response && typeof Blob !== 'undefined' && response.data instanceof Blob) {
        try {
            const data = JSON.parse(await readBlobText(response.data));
            return errorMessage({response: {...response, data}});
        } catch (parseError) {
            return errorMessage({response: {...response, data: {}}});
        }
    }
    return errorMessage(error);
}

/** Guarda el blob como archivo (enlace temporal; se revoca la URL 4 s después del clic). */
export function saveBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Revocar de inmediato puede cortar la descarga en Firefox/Safari: se difiere.
    setTimeout(() => URL.revokeObjectURL(url), 4000);
}
